import * as React from "react";
import axios from "axios";
import { Button } from "./ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "./ui/card";
import { Alert } from "./ui/alert";
import { Spinner } from "./ui/spinner";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "./ui/input-otp";
import { API_BASE_URL } from "../lib/constants";
import { useNavigate, useSearchParams } from "react-router-dom";

const timeBeforeResend = 30000;

const OTPVerificationForm = () => {
  const [otp, setOtp] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState("");
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email"); // Get a parameter by name
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(""); // Reset previous errors
    setSuccess(""); // Reset previous success messages

    if (otp.length !== 6) {
      setError("OTP must be 6 digits");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(API_BASE_URL + "/api/auth/verify-otp", {
        otp,
        email,
      });
      setSuccess("OTP verified successfully!");

      if (response.status === 200) {
        setTimeout(() => {
          navigate(`/get-started?tab=login`);
        }, 1000);
      }
      // Handle success logic (e.g., redirect, token storage, etc.)
    } catch (err) {
      setError("Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const [currentTime, setCurrentTime] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime((ct) => (ct += 1));
      if (currentTime === 100) {
        clearInterval(interval);
        setCurrentTime(0);
      }
    }, timeBeforeResend / 100);

    return () => clearInterval(interval);
  }, [currentTime]);

  if (!email) {
    return (
      <Card className="min-w-[25rem]">
        <CardHeader className="text-center">
          <CardTitle className="text-xl">Verify OTP</CardTitle>
          <CardDescription>
            Enter the one-time password sent to your email/phone
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div>
              <Alert variant="destructive" className="mt-4">
                Email not found
              </Alert>
            </div>
            <Button
              type="submit"
              className="w-full rounded-xl"
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="min-w-[25rem]">
      <CardHeader className="text-center">
        <CardTitle className="text-xl">Verify OTP</CardTitle>
        <CardDescription>
          Enter the one-time password sent to your email/phone
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit}>
          <div className="space-y-6">
            <div>
              <InputOTP
                maxLength={6}
                value={otp}
                onChange={(value) => setOtp(value)}
              >
                <InputOTPGroup>
                  <InputOTPSlot className="size-14" index={0} />
                  <InputOTPSlot className="size-14" index={1} />
                  <InputOTPSlot className="size-14" index={2} />
                  <InputOTPSlot className="size-14" index={3} />
                  <InputOTPSlot className="size-14" index={4} />
                  <InputOTPSlot className="size-14" index={5} />
                </InputOTPGroup>
              </InputOTP>
            </div>

            {error && (
              <Alert variant="destructive" className="mt-4">
                {error}
              </Alert>
            )}

            {success && (
              <Alert variant="success" className="mt-4">
                {success}
              </Alert>
            )}
            <div className="space-y-2">
              <Button
                type="submit"
                className="w-full rounded-xl"
                disabled={loading}
              >
                {loading ? <Spinner /> : "Verify OTP"}
              </Button>
              {/* <Button
                type="submit"
                className="w-full"
                variant="ghost"
                disabled={!canResend}
              >
                <div className="relative size-4">
                  {!canResend ? (
                    <svg
                      className="size-full -rotate-90"
                      viewBox="0 0 36 36"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="18"
                        cy="18"
                        r="16"
                        fill="none"
                        className="stroke-current text-white dark:text-neutral-700"
                        stroke-width="4"
                      ></circle>
                      <circle
                        cx="18"
                        cy="18"
                        r="16"
                        fill="none"
                        className="stroke-current text-blue-600 dark:text-blue-500"
                        stroke-width="4"
                        stroke-dasharray="100"
                        stroke-dashoffset={100 - currentTime}
                        stroke-linecap="round"
                      ></circle>
                    </svg>
                  ) : null}
                </div>
                Resend OTP
              </Button> */}
            </div>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default OTPVerificationForm;
